"use client";

import React from "react";
import Background from "../background/Background.tsx";
import SentinelBackground from "../background/SentinelBackground.tsx";
import AidenBackground from "../background/AidenBackground.tsx";
import AssembleXBackground from "../background/AssembleXBackground.tsx";
import AssembleZBackground from "../background/AssembleZBackground.tsx";
import GreenMartBackground from "../background/GreenMartBackground.tsx";
import MusicFactoryBackground from "../background/MusicFactoryBackground.tsx";
import SanomaBackground from "../background/SanomaBackground.tsx";
import StorytimeBackground from "../background/StorytimeBackground.tsx";
import DocuMateBackground from "../background/DocuMateBackground.tsx";
import DonutBetBackground from "../background/DonutBetBackground.tsx";
import SenuriGrandCastelloBackground from "../background/SenuriGrandCastelloBackground.tsx";
import { ProjectProps, defaultBackground } from "./projectDetails";

interface ProjectDetailsLayoutProps {
  project: ProjectProps;
  children: React.ReactNode;
}

const ProjectDetailsLayout: React.FC<ProjectDetailsLayoutProps> = ({
  project,
  children,
}) => {
  return (
    <main className="flex flex-col items-center justify-start bg-black text-white">
      {/* Background Container */}
      <div className="relative h-[300px] w-full">
        {project.id === 0 ? (
          <SentinelBackground />
        ) : project.id === 1 ? (
          <AidenBackground />
        ) : project.id === 2 ? (
          <DocuMateBackground />
        ) : project.id === 3 ? (
          <AssembleXBackground />
        ) : project.id === 4 ? (
          <AssembleZBackground />
        ) : project.id === 5 ? (
          <GreenMartBackground />
        ) : project.id === 6 ? (
          <MusicFactoryBackground />
        ) : project.id === 7 ? (
          <SanomaBackground />
        ) : project.id === 8 ? (
          <StorytimeBackground />
        ) : project.id === 9 ? (
          <DonutBetBackground />
        ) : project.id === 10 ? (
          <SenuriGrandCastelloBackground />
        ) : (
          <Background
            baseColor={project.backgroundColors?.base || defaultBackground.base}
            accentColor={
              project.backgroundColors?.accent || defaultBackground.accent
            }
            intensity={
              project.backgroundColors?.intensity || defaultBackground.intensity
            }
            mixStrength={
              project.backgroundColors?.mixStrength ||
              defaultBackground.mixStrength
            }
          />
        )}
        <div className="relative z-10 flex h-full items-center justify-center">
          <h1 className="text-4xl font-bold">{project.name}</h1>
        </div>
      </div>

      {/* Project Details */}
      <div className="relative w-full max-w-[1600px] px-4 py-12 md:px-8">
        {children}
      </div>
    </main>
  );
};

export default ProjectDetailsLayout;
